import React from 'react';
import { func, string } from 'prop-types';

import { StyledLink } from './Link.style';

/**
 * Re-usable Link component
 * @param {object} params - Object containing props
 * @param {function} onClick - onClick handler function
 * @param {string} text - Text to display in link (mandatory)
 * @return {element}
 */
const Link = ({ onClick, text }) => (
  <StyledLink onClick={onClick}>{text}</StyledLink>
);

Link.propTypes = {
  text: string.isRequired,
  onClick: func,
};

Link.defaultProps = {
  onClick: () => { },
};

export default Link;
